export default __webpack_public_path__ + "static/media/icon-title-desc-inv.b282f42b.svg";